import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { QuotePreviewPage } from '@/pages/quote/quote-preview-page'

const quotePreviewSearchSchema = z.object({
  interventionId: z.uuid().optional(),
})

export const Route = createFileRoute(
  '/_quote-flow/org/$orgId/quotes/$quoteId/preview'
)({
  component: QuotePreviewPage,
  validateSearch: quotePreviewSearchSchema,
})
